import React from "react";

function BlankPage() {
	return <div className="absolute top-0 left-0 z-20 w-full h-full bg-canvas" />;
}

export default BlankPage;
